// extracted by mini-css-extract-plugin
module.exports = {"error":"Postcode_error__tPSk0","js-has-pseudo":"Postcode_js-has-pseudo__mOj9Q"};